/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type SignatureSocialPlatform = typeof SignatureSocialPlatform[keyof typeof SignatureSocialPlatform];


export const SignatureSocialPlatform = {
  website: 'website',
  linkedin: 'linkedin',
  instagram: 'instagram',
  youtube: 'youtube',
  x: 'x',
  facebook: 'facebook',
  github: 'github',
  tiktok: 'tiktok',
} as const;
